// Die Arten der Aktivitäten-Listen: Namen, Symbole, Pfade, Listenschlüssel. Rein (mit node --test prüfbar).
import type { AktivitaetenArt } from "../api/aktivitaeten";
import type { IconName } from "../components/Icon";

export type FesteArt = Exclude<AktivitaetenArt, "custom">;

export interface ArtInfo {
  art: FesteArt;
  label: string;
  /** Wort für die Zahl: { eins: "Anruf", viele: "Anrufe" } */
  einheit: { eins: string; viele: string };
  icon: IconName;
  /** Kurzer Satz für die Startseite */
  untertitel: string;
}

export const ARTEN: ArtInfo[] = [
  { art: "anrufe", label: "Anrufe", einheit: { eins: "Anruf", viele: "Anrufe" }, icon: "telefon", untertitel: "Ein- und ausgehend" },
  { art: "emails", label: "E-Mails", einheit: { eins: "E-Mail", viele: "E-Mails" }, icon: "mail", untertitel: "Gesendet und empfangen" },
  { art: "sms", label: "SMS", einheit: { eins: "SMS", viele: "SMS" }, icon: "sms", untertitel: "Kurznachrichten" },
  { art: "whatsapp", label: "WhatsApp", einheit: { eins: "Nachricht", viele: "Nachrichten" }, icon: "sms", untertitel: "WhatsApp-Nachrichten" },
  { art: "meetings", label: "Meetings", einheit: { eins: "Meeting", viele: "Meetings" }, icon: "meeting", untertitel: "Termine mit Kunden" },
  { art: "notizen", label: "Notizen", einheit: { eins: "Notiz", viele: "Notizen" }, icon: "notiz", untertitel: "Notizen an Leads" },
];

export const CUSTOM_EINHEIT = { eins: "Eintrag", viele: "Einträge" };

export function artInfo(art: string | null | undefined): ArtInfo | undefined {
  return ARTEN.find((a) => a.art === art);
}

export function artPfad(art: FesteArt): string {
  return `/aktivitaeten/${art}`;
}

export function customPfad(typId: string): string {
  return `/aktivitaeten/custom/${encodeURIComponent(typId)}`;
}

/** Schlüssel der gemerkten Ansicht (`ListenSchluessel.aktivitaeten`, API.md 20.2): `anrufe`, … bzw. `custom:<typ_id>`. */
export function ansichtSchluessel(art: AktivitaetenArt, typId?: string | null): string {
  const teil = art === "custom" ? `custom:${typId ?? ""}` : art;
  return `aktivitaeten:${teil}`;
}

/** Symbol je Close-Typ der Aktivität (für die Befehlspalette). */
export function artIcon(art: string | null | undefined): IconName {
  if (art === "custom") return "aktivitaet";
  return artInfo(art)?.icon ?? "aktivitaet";
}
